// extracted by mini-css-extract-plugin
module.exports = {"editTemplatesLink":"_1Y1o_zkzCAGXUDj9Gy8_qv","is-toggled":"f-FucV02WLpUbGWUPxWlx"};